// import React, { useState, useEffect } from "react";
// import Alert from "@material-ui/lab/Alert";
// import { Transition } from "react-transition-group";
// import "./MessageBox.scss";

// const MessageBox = (props) => {
//   //const classes = useStyles();
//   const defaultStyle = {
//     transition: `opacity 50ms ease`,
//     opacity: 1,
//   };
//   const transitionStyles = {
//     entering: { opacity: 0.5 },
//     entered: { opacity: 1 },
//     exiting: { opacity: 0.5 },
//     exited: { opacity: 0 },
//   };
//   return (
//     <Transition
//       in={props.in}
//       timeout={{
//         appear: 100,
//         enter: 100,
//         exit: 100,
//       }}
//       appear
//       unmountOnExit
//     >
//       {(state) => (
//         <div
//           className="messagebox-container"
//           style={{ ...defaultStyle, ...transitionStyles[state] }}
//         >
//           <Alert variant="filled" severity={props.type}>
//             {props.content}
//           </Alert>
//         </div>
//       )}
//     </Transition>
//   );
// };

// export default MessageBox;

import React from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  icon: {
    "& .MuiAlert-icon": {
      color: "white !important",
    },
  },
}));

export default function MessageBox(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={props.in}
        autoHideDuration={6000}
      >
        <Alert className={classes.icon} severity={props.type}>
          {props.content}
        </Alert>
      </Snackbar>
    </div>
  );
}
